import { render, staticRenderFns } from "./LossList.vue?vue&type=template&id=5241fbb4"
import script from "./LossList.vue?vue&type=script&lang=js"
export * from "./LossList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports